<template>
  <div id="about" class="container h-100">
    <h1 class="text-center p-4">About Us</h1>
    <div class="row p-5 h-100 justify-content-center align-items-center">
      <div class="col-md-6">
        <img src="/img/svg/shop-bag/1.svg" alt="" width="400">
      </div>
      <div class="col-md-6">
        <h3>Learn More About us</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur quaerat voluptate iusto? Nihil voluptas vitae veritatis magnam reprehenderit, reiciendis ex? Libero quasi natus veniam voluptatum, voluptas exercitationem ratione consectetur et!
        </p>
          <button class="btn custom-btn btn-outline-primary mr-4">Browse Products</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>